import AvatarUpload from "%/dynamic-component-editor/standard-pages/user-settings-page/AvatarUpload.vue";
import ChangeEmail from "%/dynamic-component-editor/standard-pages/user-settings-page/ChangeEmail.vue";
import ChangePassword from "%/dynamic-component-editor/standard-pages/user-settings-page/ChangePassword.vue";
import ChangeFirstName from "%/dynamic-component-editor/standard-pages/user-settings-page/ChangeFirstName.vue";
import ChangeLastName from "%/dynamic-component-editor/standard-pages/user-settings-page/ChangeLastName.vue";
import ChangeBio from "%/dynamic-component-editor/standard-pages/user-settings-page/ChangeBio.vue";
import SplashImageUpload from "%/dynamic-component-editor/standard-pages/user-settings-page/SplashImageUpload.vue";
import UserAccount from "%/dynamic-component-editor/standard-pages/user-settings-page/UserAccount.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyUserSettings extends LegacyEntity {
  get elements() {
    return {
      AvatarUpload,
      ChangeBio,
      ChangeEmail,
      ChangePassword,
      ChangeFirstName,
      ChangeLastName,
      SplashImageUpload,
      UserAccount,
    };
  }
}
